import { DIALOG_DATA } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PopinPriceDetail } from '@components/popin-price-detail/models';
import { PopinPriceDetailService } from '@components/popin-price-detail/services';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '@shared/components/image';
import { LoaderComponent } from '@shared/components/loader';
import { PopinContainerComponent } from '@shared/components/popin-container';
import { Time } from '@shared/constants';
import { CurrentLanguageService } from '@shared/services/language';

@Component({
  selector: 'app-price-detail',
  imports: [PopinContainerComponent, ImageComponent, TranslatePipe, NgClass, LoaderComponent],
  templateUrl: './popin-price-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinPriceDetailComponent {
  data = inject(DIALOG_DATA) as PopinPriceDetail;
  showKitchen = signal(true);
  private readonly popinPriceDetailService = inject(PopinPriceDetailService);
  priceDetail = toSignal(
    this.popinPriceDetailService.read(
      '',
      {
        id: this.data.id,
        shortref: this.data.shortRef,
        language: inject(CurrentLanguageService).language.locale,
      },
      {
        cacheExpirationTime: Time.FOUR_HOURS,
      }
    )
  );
}
